import * as React from 'react';
import { Card, Tag } from '../';

interface Props {
  totals: {
    total: number;
    cash: number;
    card: number;
    creditNote: number;
    bacs: number;
    cheque: number;
    account: number;
    preAuth: number;
    online: number;
  };
}

const typeColour = (type: string) => {
  switch (type) {
    case 'ACCOUNT':
      return 'info';
    case 'CREDIT-NOTE':
    case 'PRE-AUTH':
      return 'danger';
    default:
      return 'primary';
  }
};

const renderTag = (type: string) => <Tag type={typeColour(type)}>{type}</Tag>;

const BankingExportTotalsTable = ({ totals }: Props) => (
  <Card list>
    <table>
      <thead>
        <tr>
          <th>Type</th>
          <th>Total</th>
        </tr>
      </thead>
      <tbody>
        {totals.cash !== 0 && (
          <tr>
            <td>{renderTag('CASH')}</td>
            <td>£{Number(totals.cash).toFixed(2)}</td>
          </tr>
        )}
        {totals.card !== 0 && (
          <tr>
            <td>{renderTag('CARD')}</td>
            <td>£{Number(totals.card - totals.online).toFixed(2)}</td>
          </tr>
        )}
        {totals.creditNote !== 0 && (
          <tr>
            <td>{renderTag('CREDIT-NOTE')}</td>
            <td>£{Number(totals.creditNote).toFixed(2)}</td>
          </tr>
        )}
        {totals.bacs !== 0 && (
          <tr>
            <td>{renderTag('BACS')}</td>
            <td>£{Number(totals.bacs).toFixed(2)}</td>
          </tr>
        )}
        {totals.cheque !== 0 && (
          <tr>
            <td>{renderTag('CHEQUE')}</td>
            <td>£{Number(totals.cheque).toFixed(2)}</td>
          </tr>
        )}
        {totals.account !== 0 && (
          <tr>
            <td>{renderTag('ACCOUNT')}</td>
            <td>£{Number(totals.account).toFixed(2)}</td>
          </tr>
        )}
        {totals.preAuth !== 0 && (
          <tr>
            <td>{renderTag('PRE-AUTH')}</td>
            <td>£{Number(totals.preAuth).toFixed(2)}</td>
          </tr>
        )}
        {totals.online !== 0 && (
          <tr>
            <td>{renderTag('ONLINE')}</td>
            <td>£{Number(totals.online).toFixed(2)}</td>
          </tr>
        )}
      </tbody>
    </table>
  </Card>
);

export default BankingExportTotalsTable;
